export default {
  init() {
    return {
      showAbout: false,
      showPopular: false,
      showMore: false
    };
  },

  /**
   *
   * @param {Object} moduleState
   * @param {Object} payload
   * @return {Function} Object.assign()
   */
  toggleAbout(moduleState) {
    return Object.assign({}, moduleState, {
      showAbout: moduleState.showAbout ? false : true,
      showPopular: false,
      showMore: false
    });
  },

  /**
   *
   * @param {Object} moduleState
   * @param {Object} payload
   * @return {Function} Object.assign()
   */
  togglePopular(moduleState) {
    return Object.assign({}, moduleState, {
      showAbout: false,
      showPopular: moduleState.showPopular ? false : true,
      showMore: false
    });
  },

  /**
   *
   * @param {Object} moduleState
   * @param {Object} payload
   * @return {Function} Object.assign()
   */
  toggleMore(moduleState) {
    return Object.assign({}, moduleState, {
      showAbout: false,
      showPopular: false,
      showMore: moduleState.showMore ? false : true});
  }
};



// WEBPACK FOOTER //
// ./home/en-US/js/home-footer/sdo/mutations.js